import React, { useState } from "react";

import { type NostoContextProps } from "~/providers/NostoProvider";

import { useRouteLoaderData } from "~/hooks/useRouteLoaderData";

import { ColourSwatch } from "@bared/ui";

type FacetSwatchProps = {
  data: { value: string; count: number; selected: boolean }[];
  field: string;
  handleChange: (value: string) => void;
  selectedFilters: NostoContextProps["selectedFilters"];
};

export const FacetSwatch = ({
  data,
  field,
  handleChange,
  selectedFilters,
}: FacetSwatchProps) => {
  const { swatches } = useRouteLoaderData("root");
  const [showMore, setShowMore] = useState(false);

  const handleShowMore = () => {
    setShowMore((prev) => !prev);
  };

  // Safety check: return null if data is not available
  if (!data || data.length === 0) {
    return null;
  }

  const selectedValues =
    selectedFilters.find((filter) => filter.field === field)?.value ?? [];

  const swatchOptions = data
    ?.sort((a, b) => a.value.localeCompare(b.value))
    ?.map(({ value, count }) => ({
      key: value,
      count,
      checked: selectedValues.includes(value),
      swatch: swatches.find((swatch: any) =>
        Array.isArray(swatch.linked)
          ? swatch.linked.includes(value.toLowerCase())
          : false,
      ),
    }))
    .filter((option) => option.swatch !== undefined);

  return (
    <ColourSwatch
      options={swatchOptions}
      maxOptionsToShow={10}
      handleChange={handleChange}
      showMore={showMore}
      handleShowMore={handleShowMore}
    />
  );
};
